import {
  BaseKit,
  Blockquote,
  Bold,
  BulletList,
  Clear,
  Color,
  createVuetifyProTipTap,
  FontFamily,
  FontSize,
  Highlight,
  History,
  HorizontalRule,
  Image,
  Indent,
  Italic,
  Link,
  OrderedList,
  Strike,
  Table,
  TaskList,
  TextAlign,
  Underline,
  VuetifyTiptap,
  VuetifyViewer,
} from "vuetify-pro-tiptap";
import "vuetify-pro-tiptap/style.css";

export const vuetifyProTipTap = createVuetifyProTipTap({
  lang: "en",
  fallbackLang: "en",
  markdownTheme: "omni",
  components: {
    VuetifyTiptap,
    VuetifyViewer,
  },
  extensions: [
    BaseKit.configure({
      placeholder: {
        placeholder: "Enter some text...",
      },
    }),
    Bold,
    Italic,
    Underline,
    Strike,
    // Code.configure({ divider: true }),
    // Heading,
    TextAlign,
    FontFamily,
    FontSize,
    Color,
    Highlight.configure({ divider: true }),
    // SubAndSuperScript.configure({ divider: true }),
    Clear.configure({ divider: true }),
    BulletList,
    OrderedList,
    TaskList,
    Indent.configure({ divider: true }),
    Link,
    Image.configure({
      upload(file: File) {
        console.log("file", file);
        const url = URL.createObjectURL(file);
        console.log("mock upload api :>> ", url);
        return Promise.resolve(url);
      },
    }),
    // Video,
    Table.configure({ divider: true }),
    Blockquote,
    HorizontalRule,
    // CodeBlock.configure({ divider: true }),
    History.configure({ divider: true }),
    // Fullscreen,
  ],
});
